export const DIRECT = {
  value: "DIRECT",
  key: "clients.client.categorisation.categoryForm.form.provenanceTypes.direct",
};

export const ACQUIRED = {
  value: "ACQUIRED",
  key: "clients.client.categorisation.categoryForm.form.provenanceTypes.acquired",
};

export const BROKER = {
  value: "BROKER",
  key: "clients.client.categorisation.categoryForm.form.provenanceTypes.broker",
};

export default [DIRECT, ACQUIRED, BROKER];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/categorisation/enums/categorisationProvenanceTypes.js